import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../../SectionHeading';

const AuthorBioRo = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5">
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <SectionHeading title="Despre Autor" subtitle="Biografie" />
      <div className="space-y-8">
        {[
          {
            heading: "O Viziune Panoramică",
            text: "Andrei Marius Ciomîrtan este mintea din spatele uneia dintre cele mai ambițioase cronici science fiction din memoria recentă. Opera sa cuprinde cinci secole de istorie umană — reală și imaginară — împletind fizica cuantică, colapsul geopolitic, răscumpărarea ecologică și filosofia civilizațiilor interstelar."
          },
          {
            heading: "Umanul din Spatele Epicului",
            text: "Ceea ce distinge scriitura lui Ciomîrtan este insistența sa asupra scării umane. Marea terraformare a Venusului este povestită prin ochii unei femei care jelește norii vechii planete. Lansarea primei nave interstelar a umanității este martoriată de o mamă și fiica sa într-un coridor rece. Statisticile devin profesori, fermieri, ingineri — oameni cu nume."
          },
          {
            heading: "Capitolul despre Pământ",
            text: "Prin mărturisirea autorului însuși, capitolul despre Pământ a fost scris cu rușine. Morții sunt numiți. Eșecurile sunt numărate. Cele 7,4 miliarde de oameni pierduți între apogeul Pământului din 2058 și populația sa de 3 miliarde din 2501 nu sunt abstracțiuni — sunt prețul unei civilizații care a știut și a ales să nu acționeze la timp."
          },
          {
            heading: "Torța de la Final",
            text: "Cu toate acestea, cartea insistă, pagină după pagină, că aceeași specie capabilă de toată acea distrugere este, de asemenea, capabilă să transforme Venusul în paradis, să construiască comunități la -235°C pe Triton, să lanseze o navă spre o altă stea și să stingă luminile a opt lumi în unison pentru a o privi plecând. Închide această carte nu ca cineva care a terminat de citit o poveste — ci ca cineva căruia i s-a înmânat o torță."
          }
        ].map((section, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="bg-brand-surface border border-white/5 rounded-2xl p-8"
          >
            <h3 className="text-brand-accent font-semibold text-sm uppercase tracking-widest mb-4">{section.heading}</h3>
            <p className="text-gray-300 leading-relaxed">{section.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default AuthorBioRo;